import React from 'react';
import useAuth, { type UseAuth } from '../hooks/use-auth';

export type WithAuth = UseAuth;

/** @deprecated use {@link useAuth} hook instead */
function withAuth<T extends WithAuth = WithAuth>(WrappedComponent: React.FC<T>) {
  return (props: Omit<T, keyof WithAuth>) => {
    const auth = useAuth();
    return <WrappedComponent {...(props as T)} {...auth} />;
  };
}

export default withAuth;
